module.exports = __webpack_public_path__ + "ad49455083250f3e1b67fca86362f38b.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/trainingarticle_2.jpg
// module id = 305
// module chunks = 0